import { useState, useEffect } from "react";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import { ErrorMessage, useFormik } from "formik";
import styles from "../../lib/Common/commonStyles";
import { paymentSchema } from "../../validations/schema";
import BackNextButtons from "../../lib/Common/BackNextButtons";
import { Copy } from "lucide-react";
import copy from "copy-to-clipboard";
import { IoCopy } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const PaymentDetailsTab = ({
  formData,
  updateFormData,
  currentStep,
  setCurrentStep,
  showSave,
  backStep,
  values,
}) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(
    formData?.paymentlabel || "Direct Debit"
  );
  const formik = useFormik({
    initialValues: formData?.paymentDetails,
    validationSchema: paymentSchema,
    onSubmit: (values) => {
      setCurrentStep(4);
      updateFormData({
        ...formData,
        paymentDetails: {
          ...formData?.paymentDetails,
          ...values,
          bank_data_iban:
            values?.payment_method == "bank_transfer"
              ? ""
              : formik?.values?.bank_data_iban,
        },
        paymentlabel: paymentMethod,
      });
    },
  });
  useEffect(() => {
    formik.values?.payment_method == "bank_transfer"
      ? formik.setValues({
          payment_method: formik?.values?.payment_method,
          bank_data_first_name: "",
          bank_data_last_name: "",
          bank_data_iban: formik?.values?.bank_data_iban,
          bank_transfer_iban: "DE 80 8006 3598 0000 4041 87",
          authorizePayments: false,
        })
      : formik.setValues({
          payment_method:
            formik?.values?.payment_method ||
            formData?.paymentDetails?.payment_method ||
            values?.customerType == "private"
              ? "direct_debit"
              : "",
          bank_data_first_name: formData?.personalInformation?.first_name || "",
          bank_data_last_name: formData?.personalInformation?.last_name || "",
          bank_data_iban: formik?.values?.bank_data_iban,
          bank_transfer_iban: "DE 80 8006 3598 0000 4041 87",
          authorizePayments:
            formik?.values?.authorizePayments ||
            formData?.paymentDetails?.authorizePayments,
        });
    const timeout = setTimeout(() => {
      formik.setErrors({});
    }, 10); // Delay to allow Formik validation cycle

    return () => clearTimeout(timeout);
  }, [formik.values?.payment_method]);
  const paymentMethods = [
    { id: "bank_transfer", label: "Bank Transfer" },
    { id: "direct_debit", label: "Direct Debit" },
  ];

  const renderPaymentFields = () => {
    switch (formik?.values?.payment_method) {
      case "bank_transfer":
        return (
          <div className="mt-2 mt-md-3">
            <p className="mb-2 mb-md-3 text-white fontSize14Medium lineHeight24">
              {t("payment_title")}
            </p>
            <div className="column position-relative mb-3 mb-md-5">
              <TextInputFormik
                field="bank_transfer_iban"
                formik={formik}
                placeholder="DE 80 8006 3598 0000 4041 87"
                // placeholder="DE 12 3456 7890 1234 5678 00"
                customStyles="marginBottom0"
                disable={true}
              />
              {message && <p style={{ color: "white" }}>{t(`${message}`)}</p>}
              <div
                onClick={() => {
                  const iban = formik.values.bank_transfer_iban;
                  if (iban) {
                    copy(iban);
                    setIsCopied(true);
                    setMessage("Copy");
                    // Todo: Please enable if you want to reset the icon to its original Position(Unselect)
                    setTimeout(() => {
                      setIsCopied(false);
                      setMessage("");
                    }, 3000);
                  }
                }}
                className="position-absolute  end-0 translate-middle-y me-3 pe-auto textGreen height20 width20 top25px"
                style={{
                  cursor: "pointer",
                }}
                title={t("Copy")}
              >
                {isCopied ? <IoCopy size={23} /> : <Copy size={23} />}
              </div>
            </div>
          </div>
        );

      case "direct_debit":
        return (
          <div className="mt-2 mt-md-4">
            <div style={{ ...styles.grid, ...styles.gridCols2 }}>
              <TextInputFormik
                label={t("First Name")}
                field="bank_data_first_name"
                formik={formik}
                required
              />
              <TextInputFormik
                label={t("Last Name")}
                field="bank_data_last_name"
                formik={formik}
                required
              />
            </div>
            <TextInputFormik
              label={t("IBAN")}
              field="bank_data_iban"
              formik={formik}
              placeholder="e.g. DE 12 3456 7890 1234 5678 00"
              required
            />

            <div className="mb-4 mt-3 mt-md-1">
              <div className="d-flex align-items-start gap-2">
                <TextInputFormik
                  className="form-check-input backgroundColorCommon borderColorlightgray cursor-pointer"
                  type="checkbox"
                  formik={formik}
                  field="authorizePayments"
                  customStyles="marginBottom0"
                />
                <label
                  className="form-check-label text-white fontSize14Medium lineHeight24"
                  htmlFor="authorizePayments"
                >
                  {t("payment_checkbox")}
                </label>
              </div>
              {(formik.submitCount > 0 || formik?.touched?.authorizePayments) &&
                formik?.errors?.authorizePayments && (
                  <p className="fontSize14Medium lineHeight1_2 text-pink marginNTop5 mb-0 mt-1">
                    {t(`${formik.errors?.authorizePayments}`)}
                  </p>
                )}
            </div>
            {/* <div className="mt-2 mt-md-4 mb-md-4 mb-2">
              <div className="text-white ">
                <span className=" fontSize32Bold lineHeight38">S</span>
                <span className="fontSize32semiBold-none-fontFamily">€</span>
                <span className=" fontSize32Bold lineHeight38">PA</span>
              </div>
            </div> */}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <h2 className="fontSize32Regular lineHeight38 textgreen mb-2 mb-md-5 heading-text ">
        {t("Payment Details")}
      </h2>

      <div className="mb-2 mb-md-5 ">
        <label className="form-label text-white fontSize14Medium lineHeight24 ">
          {t("How would you like to pay?*")}
        </label>
        <div className="row mb-md-4 mb-4">
          {paymentMethods.map((method) => {
            if (values?.customerType == "private") {
              if (method.id == "direct_debit")
                return (
                  <div key={method.id} className="col-sm-6 mb-2">
                    <button
                      onClick={() => {
                        formik.setFieldValue("payment_method", method.id);
                        setPaymentMethod(method.label);
                      }}
                      className={`w-100 borderRadius12 border-1 border-green fontSize16Medium lineHeight24 button_green`}
                      style={{
                        ...styles.optionButton,
                        ...(formik.values?.payment_method === method.id
                          ? styles.optionButtonSelected
                          : styles.optionButtonUnselected),
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          formik.values?.payment_method === method.id
                            ? "#23dc9f"
                            : "#522a7c";
                        e.target.style.color =
                          formik.values?.payment_method === method.id
                            ? "#421f66"
                            : "#ffffff";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor =
                          formik.values?.payment_method === method.id
                            ? "#23dc9f"
                            : "#421f66";
                        e.target.style.color =
                          formik.values?.payment_method === method.id
                            ? "#421f66"
                            : "#ffffff";
                      }}
                    >
                      {t(`${method.label}`)}
                    </button>
                  </div>
                );
            } else
              return (
                <div key={method.id} className="col-sm-6 mb-2">
                  <button
                    onClick={() => {
                      formik.setFieldValue("payment_method", method.id);
                      setPaymentMethod(method.label);
                    }}
                    className={`w-100 borderRadius12 border-1 border-green fontSize16Medium lineHeight24 button_green`}
                    style={{
                      ...styles.optionButton,
                      ...(formik.values?.payment_method === method.id
                        ? styles.optionButtonSelected
                        : styles.optionButtonUnselected),
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor =
                        formik.values?.payment_method === method.id
                          ? "#23dc9f"
                          : "#522a7c";
                      e.target.style.color =
                        formik.values?.payment_method === method.id
                          ? "#421f66"
                          : "#ffffff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor =
                        formik.values?.payment_method === method.id
                          ? "#23dc9f"
                          : "#421f66";
                      e.target.style.color =
                        formik.values?.payment_method === method.id
                          ? "#421f66"
                          : "#ffffff";
                    }}
                  >
                    {t(`${method.label}`)}
                  </button>
                </div>
              );
          })}
        </div>
        {formik.errors?.payment_method && formik.touched?.payment_method && (
          <p className="fontSize14Medium lineHeight1_2 text-pink">
            {`${formik.errors?.payment_method}`}
          </p>
        )}
      </div>

      {renderPaymentFields()}
      {formik.values?.payment_method && (
        <BackNextButtons
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          onClick={formik.handleSubmit}
          showSave={showSave}
          backStep={backStep}
          values={{ ...formData, paymentDetails: formik.values, ...values }}
        />
      )}
    </div>
  );
};

export default PaymentDetailsTab;
